import { BryntumScheduler } from "@bryntum/scheduler-react"
import {DateHelper, ObjectHelper} from "@bryntum/scheduler/scheduler.umd"
import React, { useCallback, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import DeletePopup from "../components/DeletePopup"
import EditNotePopup from "../components/EditNotePopup"
import ReleaseCreatePopup from "../components/ReleaseCreatePopup"
import ReleaseEditPopup from "../components/ReleaseEditPopup"
import { EVENT_TYPE, SELECTED_GAME } from "../constants"
import Popup from "../elements/Popup"
import {pushEventChangesInAsana, sendAddEvent, sendRemoveEvent, sendUpdateEvent} from "../requests"
import store from "../store"
import {
    beforeCopyEvent, doUseTime,
    fixEventDates,
    fixEventId,
    hasText,
    isEmptyArray,
    isExists,
    setHoursForEventDates
} from "../utils"
import { eventClick } from "./bryntum_configs/eventClick"
import {
    getLiveOpsTemplateInfoNameIfExist,
    hideEventTimeRange,
    processTimeAxisHeaderClick, replaceOrAppendDate,
    setEventTimeRange
} from "./bryntum_helpers"
import manageCalendar from "./manageCalendar"
import "./ba_styles.css"

let startDate = new Date()
startDate.setDate(startDate.getDate() - 60)
let endDate = new Date()
endDate.setDate(endDate.getDate() + 365)


const RELEASES = {
    "DEV версия": ["BC апрув", "RC апрув", "Feature freeze"],
    "Android Сабмит/Релиз": ["Release: Android", "Submit: Android"],
    "iOS Сабмит/Релиз": ["Release: iOS", "Submit: iOS"],
    "Hard/Soft Update": ["Soft Update после релиза", "Hard Update после релиза"]
}

const DSCalendar = (props) => {
    const dispatch = useDispatch()
    const labelsConfig = useSelector((state) => state.labelsConfig)

    // useEffect(() => {
    //     dispatch(fetchLabelsConfig("mc"))
    // }, [])
    const user = useSelector((state) => state.user.currentUser)
    let [existsInAsana, setExistsInAsana] = useState(false)
    const [deleteRecords, setDeleteRecords] = useState([])

    let timeInStartDate = 0

    const getEditorConfigs = () => {
        return {
            multiEventSelect: true,
            eventDragFeature: {
                constrainDragToResource: true
            },
            rowCopyPasteFeature: false,
            eventResizeFeature: true,
            eventMenuFeature: {
                items: {
                    editEventNote: {
                        text: "Edit event note",
                        icon: "b-fa b-fa-fw b-fa-sticky-note",
                        onItem({ eventRecord }) {
                            props.showNoteEditor(eventRecord)
                        }
                    },
                    eventLink: {
                        text: "Link to Asana",
                        icon: "b-fa b-fa-fw b-fa-external-link-alt",
                        weight: 0,
                        onItem({ eventRecord }) {

                            if (hasText(eventRecord.link)) {
                                window.open(eventRecord.link, "_blank")
                            }
                        }
                    },
                    pushToAsana: {
                        text: "Push to Asana",
                        icon: "b-fa b-fa-fw b-fa-angle-right",
                        onItem({ eventRecord }) {
                            pushEventChangesInAsana(eventRecord, SELECTED_GAME.DS.toLowerCase())
                        }
                    },
                    copyLink: {
                        text: "Copy link",
                        icon: "b-fa b-fa-fw b-icon-copy",
                        weight: 0,
                        onItem({ eventRecord }) {
                            if (hasText(eventRecord.link)) {
                                navigator.clipboard.writeText(eventRecord.link).then()
                            }
                        }
                    },
                    manageFeaturing: {
                        text: "Add to featuring",
                        icon: "b-fa b-fa-fw b-icon-copy",
                        onItem(item) {
                            let clonedEvent = item.eventRecord.data
                            clonedEvent.addFeaturing = true
                            // clonedEvent.startDate = clonedEvent.startDate.toString()
                            const withTime = doUseTime({ eventRecord: clonedEvent })
                            clonedEvent.useTimeInStartDate = withTime
                            clonedEvent.useTimeInEndDate = withTime

                            sendUpdateEvent(clonedEvent, SELECTED_GAME.DS.toLowerCase())
                        }
                    },
                    managePromo: {
                        text: "Add to promo",
                        type: "checkbox",
                        checked: false,
                        icon: "b-fa b-fa-fw",
                        onAction(item) {
                            if (item.checked) {
                                let currentRecord = item.source.eventRecord
                                let promoResource = props.scheduler.current.schedulerInstance.resourceStore.findRecord("name", "LiveOps Promo")
                                let clonedCurrentRecord = ObjectHelper.clone(currentRecord.data)
                                clonedCurrentRecord.id = clonedCurrentRecord.id + "_promo"
                                clonedCurrentRecord.resourceId = promoResource.id
                                clonedCurrentRecord.type = EVENT_TYPE.PROMO
                                clonedCurrentRecord.resizable = false
                                props.scheduler.current.schedulerInstance.eventStore.addAsync(clonedCurrentRecord)
                                currentRecord.setAsync("promo", true)
                                sendAddEvent(clonedCurrentRecord, SELECTED_GAME.DS.toLowerCase())


                            } else {
                                let currentRecord = item.source.eventRecord
                                let promoRecord = props.scheduler.current.schedulerInstance.eventStore.findRecord("id", currentRecord.id + "_promo")
                                currentRecord.setAsync("promo", false)

                                props.scheduler.current.schedulerInstance.eventStore.remove(promoRecord.id)
                                let clonedCurrentRecord = ObjectHelper.clone(promoRecord)
                                clonedCurrentRecord.id = currentRecord.id
                                sendRemoveEvent(promoRecord, SELECTED_GAME.DS.toLowerCase())
                            }
                        }
                    },
                    manageBrandformance: {
                        text: 'Add to Brandformance',
                        type: "checkbox",
                        checked: false,
                        icon: "b-fa b-fa-fw",
                        onAction(item) {
                            try {
                                let currentRecord = item.source.eventRecord;

                                const withTime = doUseTime({eventRecord: currentRecord})
                                currentRecord.useTimeInStartDate = withTime
                                currentRecord.useTimeInEndDate = withTime

                                if (item.checked) {
                                    let brandformanceResource = props.scheduler.current.schedulerInstance.resourceStore.findRecord("name", "Brandformance");
                                    let clonedCurrentRecord = ObjectHelper.clone(currentRecord.data);
                                    clonedCurrentRecord.id = clonedCurrentRecord.id + "_brandformance";
                                    clonedCurrentRecord.resourceId = brandformanceResource.id;
                                    clonedCurrentRecord.type = EVENT_TYPE.BRANDFORMANCE;
                                    clonedCurrentRecord.resizable = false;
                                    //props.scheduler.current.schedulerInstance.eventStore.addAsync(clonedCurrentRecord);
                                    currentRecord.setAsync("brandformance", true)
                                    sendAddEvent(clonedCurrentRecord, SELECTED_GAME.DS.toLowerCase());
                                } else {
                                    let brandformanceRecord = props.scheduler.current.schedulerInstance.eventStore.findRecord("parentCompositeEventId", currentRecord.id);
                                    currentRecord.setAsync("brandformance", false);
                                    props.scheduler.current.schedulerInstance.eventStore.remove(brandformanceRecord.id);

                                    //let clonedCurrentRecord = ObjectHelper.clone(brandformanceRecord);
                                    //clonedCurrentRecord.id = currentRecord.id;
                                    if(brandformanceRecord != undefined) {
                                        sendRemoveEvent(brandformanceRecord, SELECTED_GAME.DS.toLowerCase())
                                    }


                                }
                            } catch (error) {
                                console.error("Error in manageBrandformance menu item:", error);
                            }
                        }
                    },

                    // managePush: {
                    //     text: "Add to push notifications",
                    //     type: "checkbox",
                    //     checked: false,
                    //     icon: "b-fa b-fa-fw",
                    //     onAction(item) {
                    //         if (item.checked) {
                    //             let currentRecord = item.source.eventRecord
                    //             let pushResource = props.scheduler.current.schedulerInstance.resourceStore.findRecord("name", "Push notifications")
                    //             let clonedCurrentRecord = ObjectHelper.clone(currentRecord.data)
                    //
                    //             clonedCurrentRecord.id = clonedCurrentRecord.id + "_push"
                    //             clonedCurrentRecord.resourceId = pushResource.id
                    //             clonedCurrentRecord.type = EVENT_TYPE.PUSH
                    //             clonedCurrentRecord.endDate = clonedCurrentRecord.startDate
                    //             clonedCurrentRecord.duration = 1
                    //             clonedCurrentRecord.resizable = false
                    //
                    //
                    //             clonedCurrentRecord.endDate = DateHelper.add(clonedCurrentRecord.startDate, 1, "d")
                    //
                    //
                    //             props.scheduler.current.schedulerInstance.eventStore.addAsync(clonedCurrentRecord)
                    //             currentRecord.setAsync("push", true)
                    //             sendAddEvent(clonedCurrentRecord, SELECTED_GAME.DS.toLowerCase())
                    //
                    //         } else {
                    //             let currentRecord = item.source.eventRecord
                    //             let pushRecord = props.scheduler.current.schedulerInstance.eventStore.findRecord("id", currentRecord.id + "_push")
                    //             currentRecord.setAsync("push", false)
                    //
                    //             props.scheduler.current.schedulerInstance.eventStore.remove(pushRecord.id)
                    //             let clonedCurrentRecord = ObjectHelper.clone(pushRecord)
                    //             clonedCurrentRecord.id = currentRecord.id
                    //             sendRemoveEvent(pushRecord, SELECTED_GAME.DS.toLowerCase())
                    //         }
                    //     }
                    // },
                    cutEvent: false
                },
                processItems({ eventRecord, items }) {
                    items.managePromo.eventRecord = eventRecord
                    // items.managePush.eventRecord = eventRecord
                    items.manageFeaturing.eventRecord = eventRecord
                    items.manageBrandformance.eventRecord = eventRecord

                    function checkPromoRecord() {
                        if (eventRecord.promo) {
                            items.managePromo.checked = true
                        }
                    }

                    function checkBrandformanceRecord() {
                        if (eventRecord.brandformance) {
                            items.manageBrandformance.checked = true;
                        }
                    }
                    function checkFeaturingRecord() {
                        if (eventRecord.featuring) {
                            items.manageFeaturing.checked = true
                        }
                    }
                    //
                    // function checkPushRecord() {
                    //     if (eventRecord.push) {
                    //         items.managePush.checked = true
                    //     }
                    // }

                    checkPromoRecord()
                    // checkPushRecord()
                    checkFeaturingRecord();
                    checkBrandformanceRecord();

                    if (eventRecord.isArchive) {
                        items.editEventNote.disabled = true
                        items.editEvent.disabled = true
                        items.deleteEvent.disabled = true
                        if (items.hasOwnProperty("hideEvent")) {
                            items.hideEvent.disabled = true
                        }
                        items.copyEvent.disabled = true
                        items.managePromo.disabled = true
                        items.manageFeaturing.disabled = true
                        items.manageBrandformance.disabled = true;

                    } else if (eventRecord.type === EVENT_TYPE.HOLIDAY) {
                        items.editEventNote.hidden = true
                        items.managePromo.hidden = true
                        items.manageBrandformance.disabled = true;

                    } else if (eventRecord.type === EVENT_TYPE.RELEASE) {
                        items.copyEvent.hidden = true
                        items.managePromo.hidden = false
                        items.manageFeaturing.hidden = true
                        items.manageBrandformance.disabled = true;

                        if (isExists(eventRecord.parentRelease)) {
                            items.managePromo.hidden = true
                            items.manageFeaturing.hidden = true
                        }
                    } else if (eventRecord.type === EVENT_TYPE.ASO) {
                        items.copyEvent.hidden = true
                        items.managePromo.hidden = true
                        items.manageFeaturing.hidden = true
                        items.deleteEvent.hidden = false
                        items.manageBrandformance.disabled = true;

                    } else if (eventRecord.type === EVENT_TYPE.PROMO) {
                        items.editEventNote.hidden = true
                        items.manageFeaturing.hidden = true
                        items.editEvent.hidden = true
                        items.deleteEvent.hidden = true
                        items.copyEvent.hidden = true
                        items.managePromo.hidden = true
                        items.manageBrandformance.disabled = true;

                    } else if (eventRecord.type === EVENT_TYPE.BRANDFORMANCE) {
                        items.managePromo.hidden = true;
                        items.manageBrandformance.hidden = true;
                        items.manageFeaturing.hidden = true;
                        items.editEventNote.hidden = true;
                        items.copyEvent.hidden = true;
                        items.pushToAsana.hidden = true;
                        items.manageBevbuild.hidden = true;
                        items.manageAutorun.hidden = true;

                    } else if (eventRecord.type === EVENT_TYPE.PUSH) {
                        items.editEventNote.hidden = true
                        items.editEvent.hidden = true
                        items.deleteEvent.hidden = true
                        if (items.hasOwnProperty("hideEvent")) {
                            items.hideEvent.disabled = true
                        }
                        items.copyEvent.hidden = true
                        items.managePromo.hidden = true
                        items.manageFeaturing.hidden = true
                        items.pushToAsana.hidden = true
                        items.manageFeaturing.hidden = true
                        items.manageBrandformance.disabled = true;

                    } else if (eventRecord.type === EVENT_TYPE.COMMUNITY) {
                        items.managePromo.hidden = true
                        items.manageFeaturing.hidden = true
                        items.manageBrandformance.disabled = true;

                    } else if (eventRecord.type === EVENT_TYPE.FEATURING) {
                        items.managePromo.hidden = true
                        items.manageFeaturing.hidden = true
                        items.copyEvent.hidden = true
                        items.editEventNote.hidden = true
                        items.manageFeaturing.hidden = true
                        items.pushToAsana.hidden = true
                        items.copyLink.hidden = true
                        items.manageBrandformance.disabled = true;

                    } else if (eventRecord.type === EVENT_TYPE.IMPORTANT_DATES) {
                        items.managePromo.hidden = true
                        items.manageFeaturing.hidden = true
                        items.manageBrandformance.disabled = true;

                    }
                    if (!isExists(eventRecord.link)) {
                        items.eventLink.disabled = true
                    }
                    props.setStatusForPushToAsanaEventContextMenu(eventRecord, items)
                }
            },
            listeners: {
                beforeEventDelete: (source) => processBeforeEventDelete(source),
                beforeEventEdit: (source) => {
                    source.eventRecord.resourceId = source.resourceRecord.id
                    let eventRecord = source.eventRecord
                    let resourceRecord = source.resourceRecord
                    if (isExists(source.eventRecord.parentRelease)) {
                        eventRecord = props.scheduler.current.schedulerInstance.eventStore.getById(source.eventRecord.parentRelease)
                    }
                    if (!eventRecord.isArchive &&
                        resourceRecord.type !== EVENT_TYPE.PROMO && resourceRecord.type !== EVENT_TYPE.PUSH
                        // && resourceRecord.type !== EVENT_TYPE.FEATURING
                    ) {
                        showEditor(eventRecord, resourceRecord)
                    }

                    return false
                },
                beforeEventDrag: ({ eventRecord }) => {
                    if (!eventRecord.isArchive) {
                        if (eventRecord.type !== EVENT_TYPE.PROMO
                            && eventRecord.type !== EVENT_TYPE.PUSH
                            // && eventRecord.type !== EVENT_TYPE.FEATURING
                        ) {
                            return true
                        }
                    }
                    return false
                },
                beforeEventResize: ({ eventRecord }) => {
                    timeInStartDate = eventRecord.data.startDate.getHours()
                    if (!eventRecord.isArchive) {
                        if (eventRecord.type === EVENT_TYPE.EVENT ||
                            eventRecord.type === EVENT_TYPE.AB_TEST ||
                            eventRecord.type === EVENT_TYPE.FEATURING
                        ) {
                            return true
                        }
                    }
                    return false
                },
                timeAxisHeaderClick: (event) => {
                    processTimeAxisHeaderClick(props.scheduler, event)
                },
                eventSelectionChange: ({ action, selected, selection }) => {
                    let currentSelectedEvent = selected[0]
                    if (selection.length > 1) {
                        if (action === "select") {
                            let firstSelectedEvent = selection[0]
                            if (currentSelectedEvent.data.resourceId !== firstSelectedEvent.data.resourceId) {
                                props.scheduler.current.schedulerInstance.deselectEvent(currentSelectedEvent)
                            }
                        }
                    }
                },
                eventDrop: (event) => {
                    const originalStart = event.context.origStart
                    const originalEnd = event.context.origEnd

                    event.eventRecords.forEach((eventRecord) => {

                        fixEventDates(eventRecord, originalStart, originalEnd)
                        fixEventId(eventRecord, eventRecord.startDate)

                        if (!eventRecord.isCopy) {
                            sendUpdateEvent(eventRecord, SELECTED_GAME.DS.toLowerCase())
                        }
                    })

                    props.scheduler.current.schedulerInstance.refreshRows()
                },
                beforeCopy: (event) => {
                    return beforeCopyEvent(event)
                },
                beforePaste: (event) => {
                    if (event.resourceRecord.id === event.records[0].resourceId) {
                        return isExists(event.date)
                    } else {
                        return false
                    }
                },
                eventResizeEnd: ({ eventRecord }) => {
                    DateHelper.copyTimeValues(eventRecord.endDate, eventRecord.startDate)
                    eventRecord.duration = DateHelper.diff(eventRecord.startDate, eventRecord.endDate, "d")
                    setHoursForEventDates(eventRecord, timeInStartDate)
                    sendUpdateEvent(eventRecord, SELECTED_GAME.DS.toLowerCase())
                    hideEventTimeRange(props.scheduler)
                },
                eventClick: ({ event, eventRecord }) => {
                    setEventTimeRange(props.scheduler, eventRecord)
                    return eventClick(event, eventRecord)
                },
                scheduleClick: () => {
                    hideEventTimeRange(props.scheduler)
                }
            },
            eventCopyPasteFeature: {
                generateNewName: (eventRecord) => {
                    fixEventId(eventRecord, eventRecord.startDate);
                    return replaceOrAppendDate(eventRecord);
                },

            },
            scheduleMenuFeature: {
                processItems({ resourceRecord, items }) {
                    if (isExists(items.addEvent)) {
                        items.addEvent.disabled = false
                    }

                    if (resourceRecord.type === EVENT_TYPE.ASO
                        || resourceRecord.type === EVENT_TYPE.PROMO
                        || resourceRecord.type === EVENT_TYPE.PUSH
                        // || resourceRecord.type === EVENT_TYPE.FEATURING
                    ) {
                        items.addEvent.hidden = true
                        if (items.pasteEvent !== undefined) {
                            items.pasteEvent.hidden = true
                        }

                    } else if (resourceRecord.type === EVENT_TYPE.RELEASE) {
                        if (items.pasteEvent !== undefined) {
                            items.pasteEvent.hidden = true

                        }
                    }
                }
            },
            eventDragSelectFeature: true,
            eventDragCreateFeature: false
        }
    }

    const processBeforeEventDelete = ({ eventRecords }) => {
        const deletedEvents = eventRecords.map(
            (eventRecord) => isExists(eventRecord.parentRelease)
                ? props.eventStore.getById(eventRecord.parentRelease)
                : eventRecord
        )
        setDeleteRecords(deletedEvents)
        setExistsInAsana(!!eventRecords[0].data.link)
        props.showPopup("deleteEvents")
        return false
    }

    const showEditor = useCallback((eventRecord, resourceRecord) => {
        eventRecord.type = resourceRecord.data.type
        let popupData
        if (resourceRecord.data.type === EVENT_TYPE.EVENT) {
            popupData = { hasTime: true, type: EVENT_TYPE.EVENT, hasEndDate: true }
        } else if ([EVENT_TYPE.HOLIDAY, EVENT_TYPE.FEATURING, EVENT_TYPE.IMPORTANT_DATES].includes(resourceRecord.data.type)) {
            popupData = { hasTime: false, type: "default", hasEndDate: true }
        } else if (resourceRecord.data.type === EVENT_TYPE.AB_TEST) {
            popupData = {hasTime: true, hasEndDate: true, hasMidDate: true}
        } else if ([EVENT_TYPE.COMMUNITY].includes(resourceRecord.data.type)) {
            popupData = { hasTime: false, type: "default", hasEndDate: false }
        } else if ([EVENT_TYPE.ASO].includes(resourceRecord.data.type)) {
            popupData = { hasTime: false, type: resourceRecord.data.type, hasEndDate: true }
        } else if (eventRecord.hasGeneratedId && resourceRecord.data.type === EVENT_TYPE.RELEASE) {
            popupData = "releaseCreate"
        } else if (!eventRecord.hasGeneratedId && resourceRecord.data.type === EVENT_TYPE.RELEASE) {
            popupData = "releaseEdit"
        } else {
            popupData = { hasTime: true, type: "default", hasEndDate: true }
        }
        eventRecord.status = eventRecord.hasGeneratedId ? "create" : "update"
        props.setResourceRecord(resourceRecord)
        props.setEventRecord(eventRecord)
        props.showPopup(popupData)
    }, [])

    function getConfigs() {
        let overrideConfigs = {
            eventTooltipFeature: {

                template: data => {

                    function getEventStatus() {
                        let arrayStatusText = []
                        data.eventRecord.isArchive && arrayStatusText.push(`archive event`)
                        return !isEmptyArray(arrayStatusText) ? `<div><b>Status:</b> ${arrayStatusText.join(", ")}</div>` : ""
                    }

                    function getTemplateInfo() {
                        const templatesByGame = store.getState()?.calendarConfig?.templates
                        let templates = templatesByGame?.find(config => (config.game === SELECTED_GAME.DS && config.type === EVENT_TYPE.EVENT))?.templateGidsByName
                        if (data.eventRecord.type === EVENT_TYPE.EVENT) return getLiveOpsTemplateInfoNameIfExist(templates, data.eventRecord)
                        return !isExists(data.eventRecord?.template) ? "no template" : "unknown template"
                    }

                    return `<div>
                ${getEventStatus()}
                ${(data.eventRecord.name !== undefined) ? `<div><b>Name</b>: ${(data.eventRecord.name) + ((data.eventRecord.parentRelease !== undefined && data.eventRecord.parentRelease !== null) ? "%" : "")}</div>` : ""}
                <div><b>Date</b>: ${DateHelper.format(data.eventRecord.startDate, "Y.MM.DD")} ${DateHelper.format(data.eventRecord.startDate, "HH:mm")} - ${DateHelper.format(data.eventRecord.endDate, "Y.MM.DD")} ${DateHelper.format(data.eventRecord.endDate, "HH:mm")}</div>
                <div><b>Template name</b>: ${(getTemplateInfo())}</div>
                ${(data.eventRecord.eventId !== undefined && data.eventRecord.eventId !== null && data.eventRecord.eventId.length !== 0) ? `<div><b>Event ID</b>: ${data.eventRecord.eventId}</div>` : ""}
                ${(data.eventRecord.levelsWW !== undefined && data.eventRecord.levelsWW !== null && data.eventRecord.levelsWW.length !== 0) ? `<div><b>Levels WW</b>: ${data.eventRecord.levelsWW}</div>` : ""}
                ${(data.eventRecord.levelsBR !== undefined && data.eventRecord.levelsBR !== null && data.eventRecord.levelsBR.length !== 0) ? `<div><b>Levels BR</b>: ${data.eventRecord.levelsBR}</div>` : ""}
                ${(data.eventRecord.levelsPL !== undefined && data.eventRecord.levelsPL !== null && data.eventRecord.levelsPL.length !== 0) ? `<div><b>Levels PL</b>: ${data.eventRecord.levelsPL}</div>` : ""}
                ${(data.eventRecord.persent !== undefined && data.eventRecord.persent !== null) ? `<div><b>Persent</b>: ${data.eventRecord.persent}%</div>` : ""}
                ${(data.eventRecord.countries !== undefined && data.eventRecord.countries !== null && data.eventRecord.countries.length !== 0) ? `<div><b>Countries</b>: ${data.eventRecord.countries}</div>` : ""}
                ${(data.eventRecord.note !== undefined && data.eventRecord.note !== null && data.eventRecord.note.length !== 0) ? `<div><b>Note</b>: ${data.eventRecord.note}</div>` : ""}
        </div>`
                }
            }
        }
        return props.getBryntumConfigs(getEditorConfigs, overrideConfigs)
    }

    return (
        <>{isExists(user.email) &&
            <>
                <BryntumScheduler
                    ref={props.scheduler}
                    {...getConfigs()}
                />
                {(props.popupShown && typeof props.popupShown === "object") &&
                    <Popup
                        labelsConfig={labelsConfig}
                        eventRecord={props.eventRecord}
                        eventStore={props.eventStore}
                        resourceRecord={props.resourceRecord}
                        onSave={props.handleClickSave}
                        onClose={props.hideEditor}
                        popupData={props.popupShown}
                        game={SELECTED_GAME.DS}
                        scheduler={props.scheduler.current.schedulerInstance}
                    />
                }
                {props.popupShown === "noteEdit" && (
                    <EditNotePopup
                        eventRecord={props.eventRecord}
                        eventStore={props.eventStore}
                        game={SELECTED_GAME.DS}
                        onClose={props.hideEditor}
                    />
                )}
                {props.popupShown === "releaseCreate" && (
                    <ReleaseCreatePopup
                        closePopup={props.hideEditor}
                        eventRecord={props.eventRecord}
                        eventStore={props.eventStore}
                        dependencyStore={props.dependencyStore}
                        resourceRecord={props.resourceRecord}
                        onSave={props.handleClickSave}
                        onClose={props.hideEditor}
                        onSaveChild={props.handleClickSaveChildRelease}
                        releaseNames={RELEASES}
                        game={SELECTED_GAME.DS}
                    />
                )}
                {props.popupShown === "releaseEdit" && (
                    <ReleaseEditPopup
                        closePopup={props.hideEditor}
                        eventRecord={props.eventRecord}
                        eventStore={props.eventStore}
                        dependencyStore={props.dependencyStore}
                        resourceRecord={props.resourceRecord}
                        onSave={props.handleClickSave}
                        onClose={props.hideEditor}
                        onSaveChild={props.handleClickSaveChildRelease}
                        game={SELECTED_GAME.DS}
                    />
                )}
                {props.popupShown === "deleteEvents" && (
                    <DeletePopup
                        deleteRecords={deleteRecords}
                        eventStore={props.eventStore}
                        selectedGame={SELECTED_GAME.DS}
                        existsInAsana={existsInAsana}
                        onClose={props.hideEditor}
                        scheduler={props.scheduler}
                    />
                )}
            </>
        }
        </>)
}

export default manageCalendar(DSCalendar, SELECTED_GAME.DS)
